module.exports = __webpack_public_path__ + "static/media/4.208af52b.png";